
// /**
//  * 获取 Sider 是否收起
//  * @param state
//  * @returns {number}
//  */
// export const isSiderCollapsed = function (state) {
//   return state.siderCollapsed;
// }
/**
 * 获取是否在处在loading的请求
 * @param state
 * @returns {boolean}
 */
export const isLoading = function (state) {
  return state.loadingCounter > 0;
}
/**
 * 获取登录用户信息
 * @param state
 * @returns {null}
 */
export const userInfo = function (state) {
  return state.userInfo;
}

export const routers = function (state) {
  return state.routers;
}

export const areaOrgs = function(state){
  return state.areaOrgs;
}
/**
 * 通过哪个登陆界面进入系统：1-通用；2-昆明；3-南海妇幼
 * @param state
 * @returns {null}
 */
export const loginBy = function (state) {
  return state.loginBy;
}
export const userSetting = function (state) {
  return state.userSetting;
}



// WEBPACK FOOTER //
// ./src/store/getters.js